export const CONSTANTS = {
    DEPLOYMENTREGION: {
        GLOBAL: 'Global',
        CHINA: 'China'
    }
}